<template>
  <div>

    <div class="row">
        <div class="col-md-2">
            <button href="#" @click.prevent="newEvent('event')" class="btn btn-info full-width">{{ $t("labels.newEvent") }}</button>
        </div>
        <div class="col-md-2">
            <button href="#" @click.prevent="newEvent('health_state')" class="btn btn-info full-width">{{ $t("labels.newHealthState") }}</button>
        </div>
        <div class="col-md-2">
            <button href="#" @click.prevent="newAppointment" class="btn btn-info full-width">{{ $t("labels.newAppointment") }}</button>
        </div>
        <div class="col-md-2">
            <button href="#" @click.prevent="newSeizure" class="btn btn-info full-width">{{ $t("labels.newSeizure") }}</button>
        </div>
        <div class="col-md-2">
            <button href="#" @click.prevent="newExam" class="btn btn-info full-width">{{ $t("labels.newExam") }}</button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label for="entryFilter">{{ $t("labels.entryFilter") }}</label>
                <select class="form-control" v-model="currentFilter" @change="setFilter">
                    <option value="all">{{ $t("labels.showAll") }}</option>
                    <option value="seizures">{{ $t("labels.showSeizures") }}</option>
                    <option value="appointments">{{ $t("labels.showAppointments") }}</option>
                    <option value="events">{{ $t("labels.showEvents") }}</option>
                    <option value="activities">{{ $t("labels.showActivites") }}</option>
                    <option value="exams">{{ $t("labels.showExams") }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label for="entryFilter">{{ $t("labels.showAs") }}</label>
                <select class="form-control" v-model="presentation">
                    <option value="calendar">{{ $t("labels.calendar") }}</option>
                    <option value="list">{{ $t("labels.list") }}</option>
                </select>

            </div>
        </div>
    </div>
        <div class="col-md-12" v-if="presentation === 'calendar'">
          
            <div class="col-md-12 p-0">
              <div class="mt-3 mb-3">

                    <i class="fa fa-circle mr-2"      style="font-size:20px;color:#1abc9c;"></i><span>{{ $t("lovTypes.event")  }}</span>
                    <i class="fa fa-circle mr-2 ml-2" style="font-size:20px;color:#f1c40f;"></i><span>{{ $t("lovTypes.health_state") }}</span>
                    <i class="fa fa-circle mr-2 ml-2" style="font-size:20px;color:#3498db;"></i><span>{{ $t("models.appointment") }} </span>
                    <i class="fa fa-circle mr-2 ml-2" style="font-size:20px;color:#e74c3c;"></i><span>{{ $t("lovTypes.seizure") }} ({{ $t("labels.awake") }})</span>
                    <i class="fa fa-circle mr-2 ml-2" style="font-size:20px;color:#e67e22;"></i><span>{{ $t("lovTypes.seizure") }} ({{ $t("labels.lazy") }})</span>
                    <i class="fa fa-circle mr-2 ml-2" style="font-size:20px;color:#9b59b6;"></i><span>{{ $t("lovTypes.medical_exams") }} </span>

                </div>
            </div>
            <calendar-view
                :show-date="showDate"
                :events="calendarEvents"
                :periodChangedCallback="getEventsForPeriod"
                :locale="$i18n.locale"
                :starting-day-of-week="1"
                v-on:click-event="showEvent"
                v-on:click-date="showContextualMenu"
                class="theme-default holiday-us-traditional holiday-us-official">
                <calendar-view-header
                    slot="header"
                    slot-scope="t"
                    :header-props="t.headerProps"
                    @input="setShowDate"
                />
            </calendar-view>
           
        </div>
        <div class="col-md-12" v-if="presentation === 'list'">
            <div class="mt-3 mb-3 text-center">
                  <span style="background-color:#1abc9c;border-radius:0.25rem;padding:5px;color:white"> {{ $t("lovTypes.event")  }}</span>
                  <span style="background-color:#f1c40f;border-radius:0.25rem;padding:5px;color:white" class=" ml-2"> {{ $t("lovTypes.health_state") }}</span>
                  <span style="background-color:#3498db;border-radius:0.25rem;padding:5px;color:white" class=" ml-2"> {{ $t("models.appointment") }} </span>
                  <span style="background-color:#e74c3c;border-radius:0.25rem;padding:5px;color:white" class=" ml-2"> {{ $t("lovTypes.seizure") }} ({{ $t("labels.awake") }})</span>
                  <span style="background-color:#e67e22;border-radius:0.25rem;padding:5px;color:white" class=" ml-2"> {{ $t("lovTypes.seizure") }} ({{ $t("labels.lazy") }})</span>
                  <span style="background-color:#9b59b6;border-radius:0.25rem;padding:5px;color:white" class=" ml-2"> {{ $t("lovTypes.medical_exams") }} </span>

            </div>
            <ul>
                <li v-for="item in currentListData" :key="item.id" :class="item.type" :style="item.style" @click="showEvent(item)">
                    <h4>{{ formatString(item.type) }}</h4>
                    <h5>{{ item.title }}</h5>
                    <template v-if="item.endDate">
                      <p>{{ formatDate(item.startDate) }} - {{ formatDate(item.endDate) }}</p>
                    </template>
                    <template v-else>
                      <p>{{ formatDate(item.startDate) }}</p>
                    </template>
                    
                </li>
            </ul>
        </div>
        <div class="col-md-12 text-center" v-if="presentation === 'list'">
            <div style="display: inline-block">
                <paginate
                    :page-count="pageCount"
                    :click-handler="paginateHandler"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'">
                </paginate>
            </div>
        </div>
         <vue-simple-context-menu
                :elementId="'calendarContextualMenu'"
                :options="[
                            { id: 'new_event',        name: this.$t('labels.newEvent'), class: 'new_event' },
                            { id: 'new_health_state', name: this.$t('labels.newHealthState'), class: 'new_health_state' },
                            { id: 'new_appointment',  name: this.$t('labels.newAppointment'), class: 'new_appointment' },
                            { id: 'new_seizure',      name: this.$t('labels.newSeizure'), class: 'new_seizure' },
                            { id: 'new_exam',         name: this.$t('labels.newExam'), class: 'new_exam' },
                            ]"
                :ref="'calendarContextualMenu'"
                @option-clicked="contextualMenuOptionClicked"
              />   
    </div>
</template>

<script>
import LovService from '@/services/lov'
import EventService from '@/services/event'
import AppointmentService from '@/services/appointment'
import LovForm from '@/components/lov/LovForm'
import CalendarView from "../shared/vue-simple-calendar/CalendarView.vue"
import CalendarViewHeader from "../shared/vue-simple-calendar/CalendarViewHeader.vue"
import Progress from '@/components/patient/Progress'
import moment from 'moment'
import NewEventModal from '@/components/patient/newEventModal.vue'
import SeizureService from '@/services/seizure'
import MedicalExamsService from '@/services/medicalExams'
import Paginate from 'vuejs-paginate'
const humanizeString = require('humanize-string');

require("../shared/vue-simple-calendar/default.css")
require("../shared/vue-simple-calendar/custom.css")
require("../shared/vue-simple-calendar/holidays-us.css")

var activitiesColor   = '#1abc9c';
var healthStatusColor = '#f1c40f';
var appointmentColor  = '#3498db';
var seizureAwakeColor = '#e74c3c'
var seizureSleepColor = '#e67e22'
var medicalExamColor  = '#9b59b6';
export default {
    props: {
      patient: {
        type: Object,
        default: () => {}
      },
      bus: {
        type: Object,
        default: () => {}
      }
    },
    components: {
        CalendarView,
        CalendarViewHeader,
        Progress,
        LovForm,
        NewEventModal,
        Paginate        
    },
    data () {
        return {
            errors: [],
            lovErrors: [],
            patientId: '',
            showDate: new Date(),
            events: [],
            appointments: [],
            seizures: [],
            exams: [],
            calendarEvents: [],
            types: ['health_state','event'],
            typeList: [],
            typeId: '',
            lov: {
                name: {},
                type: 'event',
                userId: this.$store.state.user._id
            },
            event: {
                type: 'event',
                periodic: false,
                periodStep: 'weeks',
                periodStart: moment(new Date()).startOf('day').format('YYYY-MM-DD'),
                periodEnd: moment(new Date()).add(30, 'days').endOf('day').format('YYYY-MM-DD'),
                dayOfWeek: 1,
                dailyStart: '8:00',
                dailyEnd: '9:00',
                dayOfMonth: 1,
                startDate: moment(new Date()).format('YYYY-MM-DD'),
                startTime: moment().startOf('day').format('HH:mm:ss'),
                endTime: ''
            },
            video: {},
            image: {},
            showDate: new Date(),
            showLovForm: false,
            currentFilter: 'all',
            presentation: 'calendar',
            perPage: 10,
            currentListData: [],
            currentCalendarSelectedDate: null,
        }
    },
    computed: {
        pageCount() {
            return Math.ceil(this.calendarEvents.length / this.perPage)
        }
    },
    watch: {
        patient: function(val) {
            this.patientId = val.patientId
        }
    },
    methods: {
        formatString(str) {
            return humanizeString(str)
        },
        formatDate(d) {
            return moment(d).format('L')
        },
        newEvent(tp, eventDate) {
          let newEventDate = eventDate || Date.now()
          let newevent = {}
          newevent.periodic    = false
          newevent.periodStart = moment(newEventDate).startOf('day').format('YYYY-MM-DD')
          newevent.periodEnd   = moment(newEventDate).endOf('day').format('YYYY-MM-DD')
          newevent.startDate   = moment(newEventDate).startOf('day').format('YYYY-MM-DD HH:mm')
          newevent.endDate     = moment(newEventDate).endOf('day').format('YYYY-MM-DD HH:mm')
          newevent.periodStep  = 'weeks'
          newevent.dayOfWeek   = 1
          newevent.dailyStart  = '00:00'
          newevent.dailyEnd    = '23:59'
          newevent.dayOfMonth  = 1
          newevent.type        = tp
          newevent.patientId   = this.patient._id
          this.$store.state.eventModalData = newevent
          this.$store.state.currentEvent = newevent
          this.$emit('neweventmodal', tp)
        },
        getEvents: async function(tp) {
            let loader = this.$loading.show({
                color: '#ccc',
                loader: 'spinner'
            },{
                after: this.$createElement('Progress')
            })
            let events = await EventService.all(this.patient._id)
            this.events = events.data
            let eventlist = []
            if (tp == 'event') {
              this.events = this.events.filter(function(e){
                return e.type == 'event'
              })
              this.calendarEvents = this.calendarEvents.filter(event => event.type != 'event' )
            } else if (tp == 'health_state') {
              this.events = this.events.filter(function(e){
                return e.type == 'health_state'
              })
              this.calendarEvents = this.calendarEvents.filter(event => event.type != 'health_state' )
            }else {
              this.calendarEvents = this.calendarEvents.filter(event => event.type != 'event' && event.type != 'health_state' )
            }
            let calendarIds = this.calendarEvents.map(event => event.id)
            this.$nextTick(() =>  {
              if (events && events.data && events.data.length > 0) {
                let eventList = []
                for (let item in this.events) {
                    let current = this.events[item]
                    let event = {}
                    event.id = current._id
                  
                    if (current.typeValue && current.typeValue.name && current.typeValue.id != 'other') {
                        event.title = current.typeValue.name[this.$i18n.locale] ? current.typeValue.name[this.$i18n.locale] : current.typeValue.name['en']
                    } else if (current.typeValue && current.typeValue.name && current.typeValue.id == 'other' && current.typeValue.other && current.typeValue.other.length > 0) {
                        event.title = current.typeValue.other
                    } else {
                        event.title = current.type
                    }
                    if (current.shortId) {
                        event['shortId'] = current.shortId
                    }
                   
                    event.startDate = moment(current.startDate).format('YYYY-MM-DD HH:MM:SS')
                    event.endDate = moment(current.endDate).format('YYYY-MM-DD HH:MM:SS')
                    if (current.type == 'event' || current.type == 'new_event') {
                        event.style = `background-color: ${activitiesColor}; color: white`
                        event.title = `${event.title} | ${moment(current.startDate).format('HH:mm')} - ${moment(current.endDate).format('HH:mm')}`
                        event['type'] = 'event'
                    } else {
                        event.style = `background-color: ${healthStatusColor}; color: black`
                        event['type'] = 'health_state'
                    }
                    if (calendarIds.includes(event.id)) {
                      console.log('INCLUDED =>', event)
                    }
                    eventList.push(event) 
                }
                this.calendarEvents = this.calendarEvents.concat(eventList)
              }
              this.sortEvents()
              loader.hide()
            })
        },
        getAppointments: async function() {
            let appointments = await AppointmentService.all(this.patient._id)
            this.calendarEvents = this.calendarEvents.filter(function(event) { return event.type != 'appointment'})
            if (appointments && appointments.data && appointments.data.length > 0) {
              this.appointments = appointments.data
              let appointmentList = []
              for (let item in this.appointments) {
                  let current = this.appointments[item]
                  let appointment = {}
                  appointment.id = current._id
                  appointment.title = `${current.location} | ${moment(current.startDate).format('HH:mm')} - ${moment(current.endDate).format('HH:mm')}`
                  appointment.startDate = moment(current.startDate).format('YYYY-MM-DD HH:MM:SS')
                  appointment.endDate = moment(current.endDate).format('YYYY-MM-DD HH:MM:SS')
                  appointment.style = `background-color: ${appointmentColor}; color: white`
                  appointment['type'] = 'appointment'
                  appointmentList.push(appointment)
              }
              this.calendarEvents = this.calendarEvents.concat(appointmentList)
            }
            this.sortEvents()
        },
        getSeizures: async function() {
            let seizures = await SeizureService.patientSeizures(this.patient._id)
            this.calendarEvents = this.calendarEvents.filter(function(event) { return event.type != 'seizure'})
            if (seizures && seizures.data && seizures.data.length > 0) {
                this.seizures = seizures.data
                let updatedSeizures = []
                for (let cs in this.seizures) {
                    let current = this.seizures[cs]
                    let event = {}
                    event.id = current._id
                    event.title = current.type && current.type.name ? current.type.name[this.$i18n.locale] : moment(new Date(current.occuredOn)).format('HH:MM')
                    event.startDate = moment(new Date(current.occuredOn)).format('YYYY-MM-DD HH:MM:SS')
                    if (current.status == 'awake')
                      event.style = `background-color: ${seizureAwakeColor}; color: white`
                    else
                      event.style = `background-color: ${seizureSleepColor}; color: white`
                     
                    event['type'] = 'seizure'
                    updatedSeizures.push(event)
                }
                this.calendarEvents = this.calendarEvents.concat(updatedSeizures)
            }
            this.sortEvents()
        },
        getExams: async function() {
            let exams = await MedicalExamsService.all(this.patient._id)
            this.calendarEvents = this.calendarEvents.filter(function(event) { return event.type != 'exam'})
            if (exams && exams.data && exams.data.length > 0) {
                this.exams = exams.data
                let updatedExams = []
                for (let cs in this.exams) {
                    let current = this.exams[cs]
                    let event = {}
                    event.id = current._id
                    event.title = current.type.name[this.$i18n.locale]
                    event.startDate = moment(new Date(current.date)).format('YYYY-MM-DD HH:MM:SS')
                    event.style = `background-color: ${medicalExamColor}; color: white`
                    event['type'] = 'exam'
                    updatedExams.push(event)
                }
                this.calendarEvents = this.calendarEvents.concat(updatedExams)
            }
            this.sortEvents()
        },
        setShowDate(d) {
            this.showDate = d
        },
        showEvent (entry) {
            this.$refs.calendarContextualMenu.hideContextMenu()
            if (entry.originalEvent) {
                entry = entry.originalEvent
            }
            if (entry.type === 'seizure') {
                let seizure = this.seizures.find(x => x._id === entry.id)
                seizure.modal = true
                if (typeof seizure.type === 'object') {
                    seizure.type = JSON.stringify(seizure.type)
                }
                if (typeof seizure.duration === 'object') {
                    seizure.duration = JSON.stringify(seizure.duration)
                }
                if (typeof seizure.triggeringFactor === 'object') {
                    seizure.triggeringFactor = JSON.stringify(seizure.triggeringFactor)
                }
                this.$store.state.editedSeizure = seizure
                $('#seizureModal').modal()
            } else if (entry.type === 'appointment') {
                this.editAppointment(entry)
            } else if (entry.type === 'event' || entry.type === 'health_state') {
                this.editEvent(entry)
            } else if (entry.type === 'exam') {
                $('#examModal').modal()
                this.editExam(entry)
            }
            
        },
        showContextualMenu: function(item, event) {
          event.preventDefault();
          event.stopPropagation();
          let eventObj = {pageX: event.pageX, pageY: event.pageY}
          eventObj.pageY = eventObj.pageY - 70
          eventObj.pageX = eventObj.pageX + 10
          
          this.$refs.calendarContextualMenu.showMenu(eventObj, item)
        },
        contextualMenuOptionClicked (event) {
          console.log(event.option.id)
          console.log(event.item)
          if (event.option.id == 'new_event') {
            this.newEvent('event', event.item.getTime() || Date.now())
          }
          if (event.option.id == 'new_health_state') {
            this.newEvent('health_state', event.item.getTime()|| Date.now())
          }

          if (event.option.id == 'new_appointment') {
             this.$emit('newappointment',  {'appointmentDate': event.item || Date.now()})
          }

          if (event.option.id == 'new_seizure') {
              this.$emit('newseizure', event.item || Date.now())
          }
          if (event.option.id == 'new_exam') {
              this.$emit('newexam', event.item || Date.now())
          }
          
          // this.newAppointment(this.bus.currentCalendarSelectedDate || Date.now())
          // this.$emit('newseizure', this.bus.currentCalendarSelectedDate || Date.now())
          // this.$emit('newexam', this.bus.currentCalendarSelectedDate || Date.now())
        },
        showGenericModal: function(entry) {
          this.$parent.$emit('showGenericModal', entry)
          $('#genericModal').modal()
        },
        getEventsForPeriod: async function() {

        },
        newAppointment() {
            this.$emit('newappointment', Date.now())
        },
        editAppointment(current) {
            let appointment = this.appointments.find(appointment => appointment._id === current.id)
            this.$store.state.currentAppointment = appointment
            this.$emit('appointmentmodal')
        },
        editEvent(current) {
          let event = this.events.find(event => event._id === current.id)
          this.$store.state.eventModalData = event
          this.$store.state.currentEvent = event
          this.$emit('eventmodal', event.type, event.typeValue.id)
        },
        editExam(current) {
          let exam = this.exams.find(exam => exam._id == current.id)
          this.$store.state.currentExam = exam
          this.$emit('exammodal', exam.type, exam.type.id)
        },
        newSeizure() {
            this.$emit('newseizure', Date.now())
        },
        removeEvent(event, deleteAll) {
            this.events = this.events.filter(function(e){
                if (deleteAll) {
                    return e.shortId != event.shortId
                } else {
                    return e._id != event._id
                }
            })
            this.calendarEvents = this.calendarEvents.filter(function(e){
                if (deleteAll) {
                    return e['shortId'] != event.shortId
                } else {
                    return e.id != event._id
                }
                
            })
        },
        removeAppointment(event) {
            this.appointments = this.appointments.filter(function(e){
                e._id != event._id
            })
            this.calendarEvents = this.calendarEvents.filter(function(e){
                return e.id != event._id
            })
        },
        removeSeizure(event) {
            this.seizures = this.seizures.filter(function(e){
                e._id != event._id
            })
            this.calendarEvents = this.calendarEvents.filter(function(e){
                return e.id != event._id
            })
        },
        removeExam(event) {
            this.exams = this.exams.filter(function(e){
                e._id != event._id
            })
            this.calendarEvents = this.calendarEvents.filter(function(e){
                return e.id != event._id
            })
        },
        updateAppointment(app) {
            let appointment = this.appointments.find(function(a) {
                return a._id === app._id
            })
            appointment = app
            let entry = this.calendarEvents.find(function(a){
                return a.id === app._id
            })
            entry.startDate = app.date
            entry.title = `${app.type} - ${moment(app.date).format('HH:MM')}`
        },
        updateSeizure(s) {
            //s.type = JSON.parse(s.type)
            //s.triggeringFactor = JSON.parse(s.triggeringFactor)
            //s.duration = JSON.parse(s.duration)
            let seizure = this.seizures.find(function(sz){
                return sz._id === s._id
            })
            seizure = s
            let entry = this.calendarEvents.find(function(a){
                return a.id === s._id
            })
            entry.startDate = s.occuredOn
            entry.title = `${s.type['name'][this.$i18n.locale] ? s.type['name'][this.$i18n.locale] : s.type['name']['en']}`
        },
        newExam() {
            this.$emit('newexam', Date.now())
        },
        setFilter: async function() {
            if (this.currentFilter == 'seizures') {
                this.calendarEvents = []
                await this.getSeizures()
            } else if (this.currentFilter == 'appointments') {
                this.calendarEvents = []
                await this.getAppointments()
            } else if (this.currentFilter == 'exams') {
                this.calendarEvents = []
                await this.getExams()
            } else if (this.currentFilter == 'events') {
                this.calendarEvents = []
                await this.getEvents('event')
            } else if (this.currentFilter == 'activities') {
                this.calendarEvents = []
                await this.getEvents('health_state')
            }      
            else {
                await this.getEvents('all')
                await this.getAppointments()
                await this.getSeizures()
                await this.getExams()
            }
            this.changePage(1)
        },
        sortEvents() {
            this.calendarEvents = this.calendarEvents.sort(function(a,b){
                let dateA = new Date(a.startDate)
                let dateB = new Date(b.startDate)
                if (dateA < dateB) {
                    return 1
                }
                if (dateA > dateB) {
                    return -1
                } 
            })
        },
        changePage: function(currentPage) {
            this.currentPage = currentPage
            const start = (currentPage - 1) * this.perPage
            const end = currentPage * this.perPage
            this.currentListData = this.calendarEvents.slice(start, end)
        },
        paginateHandler(num) {
            this.changePage(num)
            // alert('I am clicked ' + num)
        }    
    },
    mounted: async function() {
        moment.locale(this.$store.getters.userLang)
        await this.getEvents('all')
        await this.getAppointments()
        await this.getSeizures()
        await this.getExams()
        this.changePage(1)

    }
}
</script>

<style lang="scss" scoped>

    .full-width {
        width: 100%;
    }

    ul {
        margin: 0;
        padding: 0;

        li {
            max-width: 600px;
            padding: 25px 15px 15px 15px;
            margin: 0 auto 20px auto;
            text-align: center;
            font-size: 1.4em;
            list-style-type: none;
            border-radius: 10px;
        }
    }

    .event,.exam,.seizure,.appointment {
        h4,h5,p {
            color: white;
        }
    }

   
</style>


